(() => {
  const plainText = (value) => new DOMParser().parseFromString(String(value || ''), 'text/html').body.textContent.trim();
  document.querySelectorAll('script[data-ldc-review-source]').forEach(async (source) => {
    if (source.dataset.ldcReviewParsed === 'true') return;
    source.dataset.ldcReviewParsed = 'true';
    try {
      const productId = source.dataset.ldcReviewSource;
      let payload = JSON.parse(JSON.parse(source.textContent));
      const matchesProduct = (data) => data?.products?.some((item) => String(item.domainKey ?? item.domain_key) === productId);
      if (!matchesProduct(payload)) {
        const appKey = source.dataset.ldcReviewAppkey;
        if (!appKey || !/^\d+$/.test(productId)) return;
        const endpoint = `https://api-cdn.yotpo.com/v1/widget/${encodeURIComponent(appKey)}/products/${productId}/reviews.json`;
        const response = await fetch(endpoint, { credentials: 'omit', signal: AbortSignal.timeout(8000) });
        if (!response.ok) return;
        const result = await response.json();
        payload = result.response;
      }
      if (!matchesProduct(payload)) return;
      const target = document.getElementById(`ldc-product-schema-${productId}`);
      if (!target) return;
      const schema = JSON.parse(target.textContent);
      if (!['Product', 'ProductGroup'].includes(schema['@type'])) return;
      const bottomline = payload.bottomline || {};
      const count = Number(bottomline.totalReview ?? bottomline.total_review);
      const average = Number(bottomline.averageScore ?? bottomline.average_score);
      if (!schema.aggregateRating && Number.isInteger(count) && count > 0 && Number.isFinite(average) && average >= 1 && average <= 5) {
        schema.aggregateRating = { '@type': 'AggregateRating', ratingValue: average, reviewCount: count, bestRating: 5, worstRating: 1 };
      }
      const seen = new Set();
      const reviews = (payload.reviews || []).flatMap((item) => {
        const author = plainText(item.user?.displayName ?? item.user?.display_name);
        const content = plainText(item.content);
        const score = Number(item.score);
        if (item.isShop || item.is_shop || item.isIncentivized || item.is_incentivized || !author || !content || score < 1 || score > 5 || !Number.isFinite(score) || seen.has(item.id)) return [];
        seen.add(item.id);
        const review = {
          '@type': 'Review',
          author: { '@type': 'Person', name: author },
          reviewBody: content,
          reviewRating: { '@type': 'Rating', ratingValue: score, bestRating: 5, worstRating: 1 }
        };
        const name = plainText(item.title);
        if (name) review.name = name;
        const date = String(item.createdAt || item.created_at || '').slice(0, 10);
        if (/^\d{4}-\d{2}-\d{2}$/.test(date)) review.datePublished = date;
        return [review];
      });
      if (reviews.length && !schema.review) {
        schema.review = reviews;
      }
      target.textContent = JSON.stringify(schema);
    } catch (_) {
    } finally {
      source.dataset.ldcReviewComplete = 'true';
    }
  });
})();
